import {DropdownMenuItemType, IDropdownOption} from "@fluentui/react"
import i18n from "../../i18n/config"
import {ILayout} from "../CustomTemplates/CustomTemplate"
import {InputType} from "../CustomTemplates/Validations"


interface ILookupValues {
    Name: string
    Value: string
}

/**
 * Set default options for the two Content Control lists
 * @param layout
 * @param showMetatags
 */
export const setDefaultOptions = (layout: ILayout[], showMetatags: boolean = false): IDropdownOption[] => {
    const {t} = i18n

    const contentControls: IDropdownOption[] = []

    if (showMetatags) {

        contentControls.push({
            key: `headerApproval`,
            text: t('text.metadata', {ns: 'approval'}),
            itemType: DropdownMenuItemType.Header
        })
        contentControls.push({
            key: `[#Type]`,
            text: t('title.typeMetadata', {ns: 'approval', Name: "[#Type]"}),
        })


        contentControls.push({
            key: `headerUser`,
            text: t('text.optionsUserInformation', {ns: 'common'}),
            itemType: DropdownMenuItemType.Header
        })

        contentControls.push({
            key: `[#RecordLink]`,
            text: t('text.optionsRecordLink', {ns: 'common', Name: "[#RecordLink]"})
        })
        //}

        contentControls.push({
            key: `[#Description]`,
            text: t('text.optionsRecordDescription', {ns: 'common', Name: "[#Description]"})
        })
        contentControls.push({
            key: `[#Versions]`,
            text: t('text.optionsRecordVersion', {ns: 'common', Name: "[#Versions]"})
        })
        contentControls.push({
            key: `[#FullName]`,
            text: t('text.optionsRecordCreatorFullname', {ns: 'common', Name: "[#FullName]"})
        })
        contentControls.push({
            key: `[#UserName]`,
            text: t('text.optionsRecordCreatorUsername', {ns: 'common', Name: "[#UserName]"})
        })
        contentControls.push({
            key: `[#ApplicationName]`,
            text: t('text.optionsApplicationName', {ns: 'common', Name: "[#ApplicationName]"})
        })
        contentControls.push({
            key: `[#ApplicationCategory]`,
            text: t('text.optionsApplicationCategory', {ns: 'common', Name: "[#ApplicationCategory]"})
        })
        contentControls.push({
            key: `[#AudienceName]`,
            text: t('text.optionsApplicationAudiencename', {ns: 'common', Name: "[#AudienceName]"})
        })
    }

    if (layout.length !== 0) {
        layout.sort((a, b) => a.Label.localeCompare(b.Label))

        contentControls.push({
            key: `headerCC`,
            text: t('text.optionsTemplateContentControls', {ns: 'common'}),
            itemType: DropdownMenuItemType.Header
        })

        layout.map((item) => {
            if (item.Type !== InputType.GridList && item.Type !== InputType.Paragraph && item.Type !== InputType.SectionHeader && item.Type !== InputType.LineBreak && item.Type !== InputType.HelpLink) {
                contentControls.push({text: `${item.Label} - [$${item.Id}]`, key: `[$${item.Id}]`});
            }
        })
    }

    return contentControls
}

export type {ILookupValues}
